module.exports = __webpack_public_path__ + "static/media/nx-ski-20.2fceb842.png";